import React from 'react';
import { Box, Heading, Text, Stack, Divider } from '@chakra-ui/react';

const TermsCondition = () => {
  return (
    <Box maxW="800px" mx="auto" p={6} borderWidth="1px" borderRadius="md" boxShadow="lg">
      <Heading as="h1" size="xl" textAlign="center" mb={6}>
        Terms & Conditions
      </Heading>

      <Stack spacing={6}>
        <Box>
          <Text fontWeight="bold">📖 1. Acceptance of Terms:</Text>
          <Text>
            By accessing or using the services provided by Admission Possibility, you agree to be bound by these terms and conditions.
            If you do not agree with any part of these terms, you may not use our services.
          </Text>
        </Box>

        <Box>
          <Text fontWeight="bold">💼 2. Services:</Text>
          <Text>
            Admission Possibility provides consultancy services to assist individuals in the admission process to medical colleges.
            Our services include but are not limited to providing information on medical colleges, advising on application processes, and offering guidance on admission requirements.
          </Text>
        </Box>

        <Box>
          <Text fontWeight="bold">🧑‍🎓 3. Eligibility:</Text>
          <Text>
            Our services are available to individuals who meet the eligibility criteria for admission to medical colleges.
            Admission Possibility reserves the right to refuse services to anyone for any reason at any time.
          </Text>
        </Box>

        <Box>
          <Text fontWeight="bold">💳 4. Fees and Payments:</Text>
          <Text>
            Details regarding consultancy fees and payment terms are outlined separately in the fee agreement provided to the user.
            Users are responsible for the timely payment of all applicable fees.
          </Text>
        </Box>

        <Box>
          <Text fontWeight="bold">🔍 5. Information Accuracy:</Text>
          <Text>
            While Admission Possibility strives to provide accurate and up-to-date information, we do not guarantee the accuracy,
            completeness, or reliability of any information on our website. Users are encouraged to verify all details independently.
          </Text>
        </Box>

        <Box>
          <Text fontWeight="bold">🔐 6. Confidentiality:</Text>
          <Text>
            Admission Possibility will handle user information in accordance with our privacy policy.
            Users are responsible for the accuracy and security of the information they provide.
          </Text>
        </Box>

        <Box>
          <Text fontWeight="bold">⚠️ 7. Limitation of Liability:</Text>
          <Text>
            Admission Possibility shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of the use or inability to use our services.
          </Text>
        </Box>

        <Box>
          <Text fontWeight="bold">🚫 8. Termination:</Text>
          <Text>
            Admission Possibility reserves the right to terminate services for any user who violates these terms and conditions or engages in any conduct deemed inappropriate.
          </Text>
        </Box>

        <Box>
          <Text fontWeight="bold">⚖️ 9. Governing Law:</Text>
          <Text>
            These terms and conditions are governed by and construed in accordance with the laws of [Your Jurisdiction].
            Any disputes arising out of or in connection with these terms will be subject to the exclusive jurisdiction of the courts in [Your Jurisdiction].
          </Text>
        </Box>

        <Box>
          <Text fontWeight="bold">🔄 10. Changes to Terms:</Text>
          <Text>
            Admission Possibility reserves the right to update or modify these terms and conditions at any time without prior notice.
            Users are encouraged to review the terms periodically for changes.
          </Text>
        </Box>

        <Divider />

        <Box mt={4}>
          <Text fontWeight="bold">✅ Acknowledgment:</Text>
          <Text>
            By using Admission Possibility's services, you acknowledge that you have read, understood, and agree to these terms and conditions.
          </Text>
        </Box>
      </Stack>
    </Box>
  );
};

export default TermsCondition;


// import { Box } from "@chakra-ui/react"

// const TermsCondition=()=>{
//     return(
//         <Box>TermsCondition</Box>
//     )
// }

// export default TermsCondition